import { PLAN_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux'

function getWorkoutsPlanUtil (plan) {
  return getValueReduxUtil(
    plan, PLAN_KEY.WORKOUTS
  ) || []
}

export default getWorkoutsPlanUtil
